<template>
  <b-form @submit.prevent="insertConfigInfo">
    <b-card class="border0" body-class="grpHd anal" :style="{ '--structure-name': `'${structureName} 설정'` }">
      <b-row>
        <b-col class="col-6">
          <label class="head">트리거 축</label>
          <vue-select
            class="select-container w200"
            v-model="tAxis"
            :options="triggerAxisOptions"
            :reduce="(a) => a.value"
            label="text"
            :clearable="false"
          ></vue-select>
        </b-col>
        <b-col class="col-6">
          <label class="head">트리거 값</label>
          <b-form-input v-model="trigger" type="number" step="any" class="w200"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">전 시간(초)</label>
          <b-form-input v-model="btm" type="number" step="any" class="w200"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">후 시간(초)</label>
          <b-form-input v-model="atm" type="number" step="any" class="w200"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">고유 진동수 (Hz)</label>
          <b-form-input v-model="rmf" type="number" step="any" class="w200"></b-form-input>
        </b-col>
        <b-col class="col-6">
          <label class="head">고유 진동수 오차범위</label>
          <b-form-input v-model="rmfMm" type="number" step="any" class="w200"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-6">
          <label class="head">FRF Amplitude</label>
          <b-form-input v-model="ampl" type="number" step="any" class="w200"></b-form-input>
        </b-col>
        <b-col class="col-6">
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 single-item">
          <label class="head">지반 가속도 디바이스</label>
          <vue-select
            class="select-container"
            v-model="grDvId"
            :options="grDvIdOptions"
            multiple
            :reduce="(a) => a.value"
            label="text"
            :clearable="false"
          ></vue-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 single-item">
          <label class="head">구조물 가속도 디바이스</label>
          <vue-select
            class="select-container"
            v-model="stDvId"
            :options="stDvIdOptions"
            multiple
            :reduce="(a) => a.value"
            label="text"
            :clearable="false"
          ></vue-select>
        </b-col>
      </b-row>
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-searchBtn" @click="refreshData"
          ><i class="fa fa-search"></i>조회</b-button
        >
        <b-button class="empty-modBtn" type="submit"
          ><i class="fa fa-edit"></i>{{ isEditMode ? '변경' : '등록' }}</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    VueSelect,
  },
  computed: {
    ...mapGetters(["getUserId", "getUserAuth", "getAlertOptions"]),
    isEditMode() {
      return this.configData && this.configData.trigger !== null && this.configData.trigger !== undefined;
    },
    triggerAxisOptions() {
      return [
        { value: "x", text: "X" },
        { value: "y", text: "Y" },
        { value: "z", text: "Z" },
      ];
    },
    grDvIdOptions() {
      const excludedIds = Array.isArray(this.stDvId) ? this.stDvId : [];
      return this.deviceOptions.filter(
        (option) => !excludedIds.includes(option.value)
      );
    },
    stDvIdOptions() {
      const excludedIds = Array.isArray(this.grDvId) ? this.grDvId : [];
      return this.deviceOptions.filter(
        (option) => !excludedIds.includes(option.value)
      );
    },
  },
  props: {
    stid: {
      type: String,
      required: true,
    },
    structureName: {
      type: String,
      default: "구조물",
    },
    configData: {
      type: Object,
      default: () => ({
        trigger: null,
        btm: null,
        atm: null,
        rmf: null,
        rmfMm: null,
        grDvId: null,
        stDvId: null,
        tAxis: null,
        ampl: null,
      }),
    },
  },
  data() {
    return {
      trigger: null,
      btm: null,
      atm: null,
      rmf: null,
      rmfMm: null,
      grDvId: [],
      stDvId: [],
      tAxis: null,
      ampl: null,
      deviceOptions: [],
    };
  },
  watch: {
    configData: {
      handler(newVal) {
        if (newVal) {
          this.setFormData();
        }
      },
      immediate: true,
      deep: true,
    },
    stid: {
      handler(newVal) {
        if (newVal) {
          this.getDeviceList();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.stid) {
      this.getDeviceList();
    }
    this.setFormData();
  },
  methods: {
    ...mapMutations(["setAlertTitle"]),
    getDeviceList() {
      if (!this.stid) return;

      let reqBody = {
        stid: this.stid,
      };

      this.$http
        .post("/device/getDeviceList", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            let deviceList = res.data.data.deviceList || [];
            let options = [];
            for (let i = 0; i < deviceList.length; i++) {
              options.push({
                value: deviceList[i].deviceid,
                text: deviceList[i].devicename,
              });
            }
            this.deviceOptions = options;
            this.setFormData();
          } else {
            this.setAlertTitle("디바이스 조회 실패");
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setFormData() {
      if (this.configData) {
        this.trigger = this.configData.trigger;
        this.btm = this.configData.btm;
        this.atm = this.configData.atm;
        this.rmf = this.configData.rmf;
        this.rmfMm = this.configData.rmfMm;
        this.tAxis = this.configData.tAxis;
        this.ampl = this.configData.ampl;

        if (this.configData.grDvId) {
          this.grDvId = String(this.configData.grDvId)
            .split(",")
            .map((id) => id.trim())
            .filter((id) => id !== "");
        } else {
          this.grDvId = [];
        }

        if (this.configData.stDvId) {
          this.stDvId = String(this.configData.stDvId)
            .split(",")
            .map((id) => id.trim())
            .filter((id) => id !== "");
        } else {
          this.stDvId = [];
        }
      }
    },
    insertConfigInfo() {
      if (this.tAxis === null || this.tAxis === undefined || this.tAxis === "") {
        this.setAlertTitle("트리거 축을 선택해주세요.");
        this.$bvModal
          .msgBoxOk("트리거 축을 선택해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.trigger === null || this.trigger === undefined || this.trigger === "") {
        this.setAlertTitle("트리거 값을 입력해주세요.");
        this.$bvModal
          .msgBoxOk("트리거 값을 입력해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.btm === null || this.btm === undefined || this.btm === "") {
        this.setAlertTitle("전 시간(초)을 입력해주세요.");
        this.$bvModal
          .msgBoxOk("전 시간(초)을 입력해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.atm === null || this.atm === undefined || this.atm === "") {
        this.setAlertTitle("후 시간(초)을 입력해주세요.");
        this.$bvModal
          .msgBoxOk("후 시간(초)을 입력해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.rmf === null || this.rmf === undefined || this.rmf === "") {
        this.setAlertTitle("고유 진동수 (Hz)를 입력해주세요.");
        this.$bvModal
          .msgBoxOk("고유 진동수 (Hz)를 입력해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.rmfMm === null || this.rmfMm === undefined || this.rmfMm === "") {
        this.setAlertTitle("고유 진동수 오차범위를 입력해주세요.");
        this.$bvModal
          .msgBoxOk("고유 진동수 오차범위를 입력해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (this.ampl === null || this.ampl === undefined || this.ampl === "") {
        this.setAlertTitle("FRF Amplitude를 입력해주세요.");
        this.$bvModal
          .msgBoxOk("FRF Amplitude를 입력해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }
      if (!this.grDvId || !Array.isArray(this.grDvId) || this.grDvId.length === 0) {
        this.setAlertTitle("지반 가속도 디바이스를 선택해주세요.");
        this.$bvModal
          .msgBoxOk("지반 가속도 디바이스를 선택해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      if (!this.stDvId || !Array.isArray(this.stDvId) || this.stDvId.length === 0) {
        this.setAlertTitle("구조물 가속도 디바이스를 선택해주세요.");
        this.$bvModal
          .msgBoxOk("구조물 가속도 디바이스를 선택해주세요.", this.getAlertOptions)
          .then((value) => {})
          .catch((err) => {
            console.error(err);
          });
        return;
      }

      let grDvIdStr = Array.isArray(this.grDvId) ? this.grDvId.join(",") : "";
      let stDvIdStr = Array.isArray(this.stDvId) ? this.stDvId.join(",") : "";

      var reqBody = {
        stid: this.stid,
        stname: this.stname,
        trigger: this.trigger,
        btm: this.btm,
        atm: this.atm,
        rmf: this.rmf,
        rmfMm: this.rmfMm,
        grDvId: grDvIdStr,
        stDvId: stDvIdStr,
        tAxis: this.tAxis,
        ampl: this.ampl,
      };

      const apiUrl = this.isEditMode
        ? "/frequencyResponseFunction/updateConfigInfo"
        : "/frequencyResponseFunction/insertConfigInfo";

      this.$http
        .post(apiUrl, reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.setAlertTitle(this.isEditMode ? "변경 완료" : "등록 완료");
            this.$bvModal
              .msgBoxOk(
                this.isEditMode
                  ? "구조물 가속도 정보가 변경되었습니다."
                  : "구조물 가속도 정보가 등록되었습니다.",
                this.getAlertOptions
              )
              .then((value) => {
                this.$emit("setConfigInfo");
                this.closeModal();
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    refreshData() {
      this.setFormData();
    },
    isNumeric(num) {
      if (num === null || num === undefined || num === "") return true;
      num = String(num).replace(/^\s+|\s+$/g, "");
      var regex =
        /^[+\\-]?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+){1}(\.[0-9]+)?$/g;
      if (regex.test(num)) {
        num = num.replace(/,/g, "");
        if (isNaN(num)) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    showNumericErrorMessage(title) {
      this.setAlertTitle();
      this.$bvModal
        .msgBoxOk(title + " 값을 확인해주세요.", this.getAlertOptions)
        .then((value) => {})
        .catch((err) => {
          console.error(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("frequencyResponseFunctionModal");
    },
  },
};
</script>

<style lang="scss">
#frequencyResponseFunctionModal .modal-dialog {
  max-width: 950px;
  & .modal-content {
    & .card {
      padding: 0 30px 30px;
      & .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;
        & .row {
          height: 50px;
          & .col {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 10px 0;
            & label {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              color: #b4b7bd;
              width: 200px;
              height: 100%;
              margin-bottom: 0;
              margin-right: 10px;
              flex-shrink: 0;
            }
            & input,
            & select {
              width: 200px;
            }
            & .select-container {
              & .vs__dropdown-toggle {
                width: 100%;
                height: 35px;
                margin-right: 0px;
              }
            }
            &.single-item {
              & input,
              & select {
                flex: 1;
                max-width: calc(100% - 220px);
              }
              & .select-container {
                flex: 1;
                max-width: calc(100% - 220px);
                & .vs__dropdown-toggle {
                  width: 100%;
                  height: 35px;
                  margin-right: 0px;
                }
                & .vs__selected {
                  background-color: #7367f0 !important;
                  color: #ffffff !important;
                  border: 1px solid #7367f0 !important;
                  padding: 2px 8px !important;
                  border-radius: 4px !important;
                  font-weight: 500 !important;
                  margin: 2px 4px 2px 0 !important;
                  display: inline-flex !important;
                  align-items: center !important;
                }
                & .vs__deselect {
                  fill: #ffffff !important;
                  margin-left: 4px !important;
                  &:hover {
                    fill: #f0f0f0 !important;
                  }
                }
              }
            }
          }
        }
        &.grpHd {
          &::before {
            display: block;
            position: absolute;
            top: -15px;
            left: 50px;
            font-size: 16px;
            font-weight: 600;
            border: 1px solid #7367f0;
            border-radius: 10px;
            color: #b4b7bd;
            background: #283046;
            padding: 1px 10px 3px;
            letter-spacing: 1px;
            content: var(--structure-name, "구조물 가속도 정보 설정");
          }
        }
      }
      &:first-child {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis/FrequencyResponseFunctionModal.vue